import script from "./IiccCertification.vue?vue&type=script&setup=true&lang=js"
export * from "./IiccCertification.vue?vue&type=script&setup=true&lang=js"

import "./IiccCertification.vue?vue&type=style&index=0&id=7df6a1ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df6a1ab"]])

export default __exports__